import React, { useState } from 'react';
import { Product } from '../lib/types';
import { cn } from '../utils';

interface ProductFilterProps {
  products: Product[];
  shownProducts: Set<string>;
  onToggleProduct: (productName: string) => void;
}

const ProductFilter: React.FC<ProductFilterProps> = ({ products, shownProducts, onToggleProduct }) => {
  const [visible, setVisible] = useState<boolean>(true);

  return (
    <div className="w-full">
      <div className="flex items-center px-2 py-1 font-medium text-sm text-gray-900 border-b border-gray-200 mb-1">
        <span>Products</span>
      </div>
      {visible && (
        <div className="flex flex-col gap-1.5 w-full">
          {products.map((product) => {
            const isChecked = shownProducts.has(product.Name);
            const checkboxId = `product-checkbox-${product.Name.replace(/\s+/g, '-')}`;
            return (
              <label 
                key={product.Name} 
                htmlFor={checkboxId}
                className={cn(
                  'flex items-center w-full px-2 py-1 font-medium rounded-md cursor-pointer',
                  'text-xs',
                  isChecked
                    ? 'bg-gray-100 text-gray-900'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                )}
              >
                <input 
                  type="checkbox" 
                  id={checkboxId}
                  checked={isChecked} 
                  onChange={() => onToggleProduct(product.Name)}
                  className="mr-2"
                />
                {product.Name}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProductFilter;
